export default "__VITE_ASSET__BkCX7Lgc__"